import { gql } from "generated-graphql";

/**
 * A manifest's discrepancy event log, read by the row expanders.
 *
 * Its own document rather than a field on BULK_MANIFEST_DISCREPANCIES_QUERY,
 * which is asked for hundreds of rows at once and would carry every one of
 * their event logs. This one is fetched on the first expand of a manifest and
 * served from Apollo's cache on later expands. It covers every discrepancy on
 * the manifest, not just the expanded row, so that one refetch by operation
 * name after a mutation keeps every open row's history current.
 *
 * Its own module, not an export from the component file, because a file that
 * exports both components and constants defeats Vite's Fast Refresh.
 */
export const DISCREPANCY_EVENTS_QUERY = gql(`
  query DiscrepancyEvents($processedManifestId: ID!) {
    manifestDiscrepancies(processedManifestId: $processedManifestId) {
      id
      events {
        id
        eventType
        createdAt
        actorId
        actor {
          id
          person {
            first
            last
          }
        }
        eManifestValue
        vendorValue
        manifestDocumentValue
        resolutionPath
        correctValueSource
        appliedTo
        resolutionNote
      }
    }
  }
`);
